module.exports = __webpack_public_path__ + "static/img/photo_loading.b95ddef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/space/photo_loading.png
// module id = b6Mi
// module chunks = 1